export const fileDraggerLegacyString = {
  ImageExperience_Drag_File_Description: _TL_('Upload or drag and drop your images here'),
  ImageExperience_Drag_File_Minimum_Size_Tip: _TL_('Minimum size: {{width}} x {{height}} pixels'),
  ImageExperience_Drag_File_Maximum_Upload_Num: _TL_('You can upload up to {{maxCount}} images to your ad.'),
  ImageExperience_Drop_File_Description: _TL_('Drop your files to upload'),
  ImageExperience_Drop_Image_Description: _TL_('Drag and drop your images here to upload them'),
  FilePicker_ButtonText_ChooseFile: _TL_('Browse'),
  FilePicker_ButtonText_RemoveFile: _TL_('Remove file'),
};
